export default __webpack_public_path__ + "static/media/feat-uipath-irisi-og-img.bcbe1a5f.jpg";